// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"e1f60a7b7812c7a4150c","293":"38144cb151ed30a21e6e","518":"c8eae7da8352e0982fd8","779":"65852117a38913817c42"}[chunkId] + ".js";
};